import { Box, Typography } from "@mui/material";
import { semanticColors } from "../../utils/colors";
import { typography } from "../../utils/typography";
import { useTranslation } from "react-i18next";

export function PlanMedicationTitle({ activeTab, onTabChange }) {
  const { t } = useTranslation();

  const tabs = [
    { label: t("planMedication.activeReceipts"), value: "active" },
    { label: t("planMedication.receiptHistory"), value: "history" }
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "16px",
        mb: "32px"
      }}
    >
      <Box
        sx={{
          bgcolor: semanticColors.highlight.low,
          borderRadius: "650px",
          px: "13px",
          py: "6px"
        }}
      >
        <Typography
          sx={{
            ...typography.body.sSemibold,
            color: semanticColors.text.link,
            textTransform: "uppercase",
            letterSpacing: "0.08em"
          }}
        >
          {t("planMedication.label")}
        </Typography>
      </Box>

      <Typography
        sx={{ ...typography.heading.xl, color: semanticColors.text.primary }}
      >
        {t("planMedication.myMedications")}
      </Typography>

      <Box
        sx={{
          bgcolor: "white",
          borderRadius: "30px",
          p: "6px",
          display: "flex",
          gap: "4px",
          border: `0.25px solid ${semanticColors.border.middle}`,
          boxShadow: "0px 0px 4px rgba(30, 39, 79, 0.12)"
        }}
      >
        {tabs.map(tab => (
          <Box
            key={tab.value}
            onClick={() => onTabChange(tab.value)}
            sx={{
              px: "12px",
              height: "40px",
              minWidth: "120px",
              borderRadius: "30px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background:
                activeTab === tab.value
                  ? semanticColors.gradient.surface
                  : "transparent",
              filter:
                activeTab === tab.value
                  ? "drop-shadow(0px 2px 12px rgba(0, 0, 0, 0.08))"
                  : "none",
              transition: "background 0.2s"
            }}
          >
            <Typography
              sx={{
                ...typography.body.sSemibold,
                color:
                  activeTab === tab.value
                    ? "white"
                    : semanticColors.text.primary
              }}
            >
              {tab.label}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
